import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { Select, MenuItem, FormControl, FormControlLabel, TextField, Radio, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useDispatch, useSelector } from "react-redux";
import ApiService from "../../../functions/apiService";
import { setDashboardEmployeeToSwap } from "../../../store/dashboardReducer";
import Error from "../../Error/Error";
import { getGridStringOperators } from "@mui/x-data-grid";
import ConfModal from "../../Modal/ConfModal";
import MyTable from "../../Schedule/MyTable";
import EmptyState from "../../Error/EmptyState";
import { toast } from 'react-toastify';

export default function ViewActiveLocks() {
    // const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();

    const {
        register,
        control,
        formState: { errors },
        handleSubmit,
        setError,
        setValue,
        getValues,
        reset,
        watch
    } = useForm({
        defaultValues: {
            value: 'RTO_VAC'
        },
    });
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [modalData, setModalData] = useState([]);
    let columns = [
        {
            field: 'Name', headerName: 'Name', flex: 1, minWidth: 120,
            valueGetter: (params) => params.row.employee.First_name + ' ' + params.row.employee.Last_name,
            filterOperators: getGridStringOperators().filter(
                (operator) => operator.value === "contains"
            ),
        },
        {
            field: 'Function', headerName: 'Function', flex: 1, minWidth: 120,
            filterOperators: getGridStringOperators().filter(
                (operator) => operator.value === "contains"
            ),
        },
        {
            field: 'Lock_Type', headerName: 'Lock Type', flex: 1, minWidth: 120,
            filterOperators: getGridStringOperators().filter(
                (operator) => operator.value === "contains"
            ),
        },
        {
            field: 'Expire_Time', headerName: 'Expire Time', flex: 1, minWidth: 120,
            filterOperators: getGridStringOperators().filter(
                (operator) => operator.value === "contains"
            ),
        },

    ];
    const onSubmit = (body) => {
        setLoading(true);
        ApiService.get('/getUserLock/' + body.value)
            .then(({ data }) => {
                setLoading(false);
                console.log('data', data.data);
                setModalData(data.data)
                setOpen(true);
                toast.success('Success')
                // enqueueSnackbar('success', { variant: 'success' });
            }).catch(({ data }) => {
                setLoading(false);
                toast.error('Error')
                // enqueueSnackbar('Error', { variant: 'error' });
            });
    }
    let closeModal = () => {
        setOpen(false);
    }

    return <>
        <Typography fontWeight='700' fontSize="16px"> View Active Locks by Type</Typography>
        <form onSubmit={handleSubmit(onSubmit)} className="row">

            <div className="col-12 col-md-6 col-lg-3 mt-2">
                <FormControl
                    required={true}
                    fullWidth
                >
                    <TextField
                        className="mt-2"
                        InputProps={{
                            sx: {
                                height: '48px',
                            }
                        }}
                        sx={{ '& .MuiInputBase-input': { height: '39px' } }}
                        size="small"
                        {...register("value", { required: "Value  is required." })}
                    />
                    {errors.value && (<Error >{errors.value?.message}</Error>)}
                </FormControl>
            </div>
            <div className="col-12 mt-3">
                <ButtonTheme disabled={loading} color='primary' type='submit'>View Locks</ButtonTheme>
            </div>


        </form>
        <ConfModal Title='Employees' open={open} closeModal={closeModal} >

            {modalData && modalData && modalData.length > 0 &&

                <div >
                    <MyTable
                        rows={modalData}
                        columns={columns}
                        useTopFilter={false}
                        checkboxSelection={false}
                        hideFooter={true}
                    />
                </div>
            }
            {modalData && modalData && modalData.length == 0 &&
                <div>
                    <EmptyState text="No Employee" />
                </div>
            }
        </ConfModal>
    </>
}
